import React from 'react';
import Sidebar from './Sidebar';
import MobileMenu from './MobileMenu';

const AgentOpsContainer = ({
  children,
  onLogout
}) => {
  return (
    <div className="page-root">
      <Sidebar onLogout={onLogout} />
      <MobileMenu />
      <div className="dashboard-container agentops-container">
        
          {
            children
          }

      </div>
    </div>
  );
};

export default AgentOpsContainer;
